// Send the session token as a header, never in a download URL or browser history.
export default async function download(path, filename) {
  const user=JSON.parse(localStorage.getItem('xm-user') || '{}');
  const response=await fetch(process.env.VUE_APP_BASEURL+path,{headers:{token:user.token || ''}});
  if(!response.ok) throw Error('下载失败，请检查登录状态');
  if((response.headers.get('content-type') || '').includes('application/json')) {
    const body=await response.json();throw Error(body.msg || '下载失败');
  }
  const blob=await response.blob();const url=URL.createObjectURL(blob);const a=document.createElement('a');
  a.href=url;a.download=filename;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
